import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ExpandSvg = function ExpandSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.222 2H2v7.222h1.481V4.53l6.143 6.143 1.048-1.048-6.143-6.143h4.693zM19.471 20.519l-6.143-6.143 1.048-1.048 6.143 6.143v-4.693H22V22h-7.222v-1.482zM2 14.778h1.481v4.693l6.143-6.143 1.048 1.048-6.143 6.143h4.693V22H2zM19.471 3.481h-4.693V2H22v7.222h-1.482V4.53l-6.142 6.143-1.048-1.048z"
  }));
};
export var Expand = function Expand(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ExpandSvg
  }));
};